import { useMemo } from 'react';
import { useMutation } from '@edreamsodigeo/frontend-api-client';
import {
  ItinerarySearchAlternativesMutation,
  ItinerarySearchAlternativesMutationVariables,
} from 'generated/graphql';
import { ITINERARY_SEARCH_ALTERNATIVES } from 'clientState/providers/operations/itinerarySearchAlternatives';
import { useLogFrontendApiError } from '@edreamsodigeo/frontend-core';

export const useAlternativeItineraryMutation = () => {
  const mutationResult = useMutation<
    ItinerarySearchAlternativesMutation,
    ItinerarySearchAlternativesMutationVariables
  >(ITINERARY_SEARCH_ALTERNATIVES);
  const { mutate, loading, data, errors } = mutationResult;
  const searchId = data?.itinerarySearchAlternatives?.searchId;
  const alternativeItinerary =
    data?.itinerarySearchAlternatives?.itineraries[0];
  const carriers = data?.itinerarySearchAlternatives?.carriers;
  const locations = data?.itinerarySearchAlternatives?.locations;
  const carbonFootprints = data?.itinerarySearchAlternatives?.carbonFootprints;

  useLogFrontendApiError(mutationResult);

  return useMemo(
    () => ({
      mutate,
      loading,
      errors,
      searchId,
      alternativeItinerary,
      carriers,
      locations,
      carbonFootprints,
    }),
    [
      mutate,
      loading,
      errors,
      searchId,
      alternativeItinerary,
      carriers,
      locations,
      carbonFootprints,
    ]
  );
};
